import React from 'react';

export const MentionsLegales = () => {
  return (
    <div className="max-w-[1200px] mx-auto px-6 py-10 bg-white">
      <h1>Mentions légales de Mon Activité Apprentissage « MAP »</h1>
      <p className="text-sm text-[#666] mb-8">Version 1 du 04/05/2026</p>

      <section className="mb-8">
        <h2>Objectif de l’information diffusée</h2>
        <p>
          Le présent site <a
          href={'https://ofa-map-apprentissage.francecompetences.fr'}>https://ofa-map-apprentissage.francecompetences.fr</a>,
          appelé Mon Activité
          Apprentissage « MAP », a pour objet de permettre le dépôt des enquêtes relatives à leur
          comptabilité analytique par les Centres de Formation d’Apprentis (CFA).
        </p>
      </section>

      <section className="mb-8">
        <h2>Éditeur</h2>
        <p>
          Mon Activité Apprentissage « MAP » est édité par France compétences, établissement public national à caractère
          administratif créé par la loi n° 2018-771 du 5 septembre 2018 pour la liberté de choisir son avenir
          professionnel (décret paru au J.O. du 30 décembre 2018), immatriculé sous le numéro SIRET 130 024 565 00025 et
          dont le siège social est situé 6 rue du Général Audran – 92400 Courbevoie.
        </p>
        <p>
          A noter qu’à compter du 1er janvier 2019, France compétences s’est substituée au Fonds paritaire de
          sécurisation des parcours professionnels (FPSPP) dans ses droits et obligations de toute nature.
        </p>
        <p>
          <strong>Directeur de la publication :</strong> Monsieur Stéphane LARDY, Directeur général de France
          compétences.
        </p>
      </section>

      <section className="mb-8">
        <h2>Gestion éditoriale</h2>
        <p>Les contenus de Mon Activité Apprentissage « MAP » sont rédigés par les services de France compétences.</p>
      </section>

      <section className="mb-8">
        <h2>Contact</h2>
        <p>
          <strong>Adresse du siège social :</strong> France compétences, 6 rue du Général Audran – 92400
          Courbevoie<br />
          <strong>Adresse mail :</strong> comptes-apprentissage@francecompetences.fr<br />
          <strong>Numéro institutionnel :</strong> 01 81 69 01 40<br />
          <strong>Numéro standard Comptabilité analytique :</strong> 09 71 16 64 23<br />
        </p>
      </section>

      <section className="mb-8">
        <h2>Coordonnées de l’hébergeur du site internet</h2>
        <p>
          <strong>CEGEDIM</strong>, société anonyme, immatriculée au RCS de Nanterre No B 350 422 622 dont le siège
          social est situé 137 rue d’Aguesseau, 92100 Boulogne-Billancourt
        </p>
      </section>

      <section className="mb-8">
        <h2>Ergonomie, graphisme et intégration</h2>
        <p>
          <strong>THALES SERVICES NUMERIQUES SAS</strong>, société par actions simplifiée à associé unique, immatriculée
          au RCS de Versailles sous le numéro 428 677 124, dont le siège social est situé 19-21 Avenue Morane Saulnier,
          78140 Vélizy-Villacoublay.
        </p>
      </section>

      <section className="mb-8">
        <h2>Droits de propriété intellectuelle</h2>
        <p>
          Mon Activité Apprentissage « MAP » constitue une œuvre protégée par le droit de la propriété intellectuelle,
          dont France compétences est titulaire. Toute reproduction, intégrale ou partielle, est systématiquement
          soumise à l’autorisation de France compétences.
        </p>

        <h3>Droit d’auteur</h3>
        <p>
          Les textes, les images, les dessins, le lay-out, ainsi que la charte graphique de Mon Activité Apprentissage «
          MAP » sont protégés par le droit d’auteur, en application des articles L. 111-1 et suivants du code de la
          propriété intellectuelle.
        </p>
        <p>
          Il est interdit de copier, extraire, diffuser ou modifier le contenu de Mon Activité Apprentissage « MAP » à
          des fins commerciales. Le téléchargement ainsi que l'impression de texte, images et éléments graphiques sont
          autorisés au seul usage privé et non commercial. La reproduction de dessins, images, documents sonores,
          séquences vidéo et textes dans d'autres publications électroniques ou imprimées nécessite le consentement
          écrit préalable de France compétences.
        </p>
        <p>
          Le défaut d'autorisation est sanctionné par le délit de contrefaçon prévu à l’article L. 335-2 du code de la
          propriété intellectuelle.
        </p>

        <h3>Marques</h3>
        <p>
          Les marques et logos figurant sur Mon Activité Apprentissage « MAP » sont des marques déposées auprès de
          l’Institut national de la propriété industrielle (INPI).
        </p>
        <p>
          Toute reproduction totale ou partielle des marques et/ou logos présents sur Mon Activité Apprentissage « MAP »
          , effectuée à partir des éléments de celui-ci sans l'autorisation expresse de France compétences est
          constitutive de contrefaçon sanctionnée par les articles L. 713-2 et suivants du code de la propriété
          intellectuelle.
        </p>

        <h3>Bases de données</h3>
        <p>
          Les bases de données établies par France compétences sont protégées par les articles L. 341-1 et suivants du
          code de la propriété intellectuelle. Figurent notamment parmi celles-ci les bases de données alimentées par
          les enquêtes déposées par les organismes sur Mon Activité Apprentissage « MAP ».
        </p>
        <p>
          Sauf autorisation écrite de France compétences, toute reproduction, représentation, adaptation, traduction
          et/ou modification, partielle ou intégrale ainsi que toute extraction substantielle qualitative ou
          quantitative vers une autre plateforme de ces bases de données est interdite et sanctionnée par les articles
          L. 343-4 et suivants du code de la propriété intellectuelle.
        </p>
      </section>
    </div>
  );
};